import { CircularProgress, styled } from "@mui/material";

export const LoadingSpinner = styled(CircularProgress)(() => ({
    width: "10px"
  }))